import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import TheaterSeatPicker from './TheaterSeatPicker';
import ImaginePage from './ImaginePage';
import StocksPage from './StocksPage';
import AdminPage from './AdminPage';
import "./App.css";
import HeroSection from './HeroSection';
import SkillsSection from './SkillsSection';
import ContactSection from './ContactSection';
import TopBar from './TopBar';
import { ThemeProvider } from './ThemeContext';
import SitePasswordGate from './SitePasswordGate';

function MainAppContent() {
  return (
    <div className="app-container" style={{ minHeight: "100vh", background: "var(--white)", position: "relative", paddingBottom: 40 }}>
      {/* Hero / Intro Section */}
      <HeroSection />
      {/* Skills Section */}
      <SkillsSection />
      {/* Contact Section */}
      <ContactSection />
    </div>
  );
}


function App() {
  return (
    <ThemeProvider>
      <SitePasswordGate>
        <Router>
          <TopBar />
          <Routes>
            <Route path="/theater" element={<TheaterSeatPicker />} />
            <Route path="/imagine" element={<ImaginePage />} />
            <Route path="/stocks" element={<StocksPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/*" element={<MainAppContent />} />
          </Routes>
        </Router>
      </SitePasswordGate>
    </ThemeProvider>
  );
}

export default App;
